<template>
  <div id="tagManager">
    <div class="allMenuHead">
      <div v-if="$childMenu.indexOf('标签管理') >= 0" :class="step===1 ? 'active' : ''" @click="toUrl('tagList', 1)" class="d_i headTab p_r">标签管理<div class="p_a"></div></div>
      <div v-if="$childMenu.indexOf('AI标签分析') >= 0" :class="step===2 ? 'active' : ''" @click="toUrl('aiTagList', 2)" class="d_i headTab p_r">AI标签分析<div class="p_a"></div></div>

    </div>
    <div class="allHeaderRouter">
      <transition name="fadeLeft">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
let Time
  export default {
    name: 'tagManager',
    data () {
      return {
        step: 1,
        isSystemAdmin: window.sessionStorage.getItem('isSystemAdmin'),
        appowner: JSON.parse(window.sessionStorage.getItem('nowApp'))
      }
    },
    created () {
      Time = setInterval(p => {
        if (window.location.href.indexOf('tagList') >= 0) {
          this.step = 1
        } else if(window.location.href.indexOf('aiTagList') >= 0){
          this.step = 2
        }
      }, 100)
    },
    destroyed () {
      clearInterval(Time)
    },
    methods: {
      toUrl (url, num) {
        
        this.step = num
        
        this.$router.push({
          name: url
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/tagManager/tagManager.vue